import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router';
import Button from '../../../component/button';
import { isEmail, isEmpty } from '../../../helpers/common';
import AppLogo from '../../../component/appLogo';
import {
  Content,
  Form,
  FormBlock,
  FormText,
  FormText1,
  FormTextArea,
  FormView,
  Group,
  Icon,
  InputValue,
  ResetView,
  Title,
  Viewer
} from '../styles';
import { rootStore } from '../../../mobx/rootStore';
import LayoutWithoutNavbar from '../../../component/layoutWithoutNavbar';
import { BUTTON_TYPE } from '../../../global/constants';
import { ROUTES } from '../../../routes/urls';

const DeleteUser: React.FC = () => {
  //State
  const [email, setEmail] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  //Other variable
  const history = useHistory();

  // for deleting user
  const onDeleteUser = useCallback(
    (e: React.SyntheticEvent) => {
      e.preventDefault();
      if (isEmpty(email)) {
        rootStore.alertNotificationStore.setErrorMessage('Please enter email!');
        return;
      } else if (!isEmail(email)) {
        rootStore.alertNotificationStore.setErrorMessage('Please enter valid email!');
        return;
      }
      setIsDeleted(true);
    },
    [email]
  );

  return (
    <>
      <LayoutWithoutNavbar>
        <Group isDeleteUserPage={true} className='windows-onboarding-flow'>
          <Content isSent={isDeleted}>
            <Icon>
              <AppLogo height={60} />
            </Icon>

            {isDeleted ? <></> : <Title> Delete user</Title>}
            {isDeleted ? (
              <>
                <ResetView>
                  <Title>Account deletion process initiated.</Title>
                  <FormText isSent={isDeleted}>
                    <p>
                      If there's an account associated with this email, Please check your email within the next 24 hours
                      and click the provided link to complete the account deletion process.
                    </p>
                  </FormText>
                </ResetView>
              </>
            ) : (
              <FormView>
                <Form onSubmit={onDeleteUser}>
                  <FormBlock>
                    <InputValue
                      onChange={(e) => setEmail(e.target.value)}
                      typeof='email'
                      placeholder='Email Address'
                      value={email}
                    />
                  </FormBlock>
                  <Button title='Delete' variant={BUTTON_TYPE.PRIMARY} buttonType='submit' />
                </Form>
                <FormTextArea>
                  <FormText1>
                    <Viewer
                      role='button'
                      onClick={() => {
                        history.push(ROUTES.LOGIN);
                      }}>
                      Back to Login
                    </Viewer>
                  </FormText1>
                </FormTextArea>
              </FormView>
            )}
          </Content>
        </Group>
      </LayoutWithoutNavbar>
    </>
  );
};

export default DeleteUser;
